import React, { useCallback, useEffect, useState } from "react";
import ErasureMethodForm from "./ErasureMethodForm";
import { Paper, withStyles, Dialog } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { parseURL } from "../../sc-utilities";
import { connect } from "react-redux";
import * as Yup from "yup";
import * as actions from "./store/erasureMethodActions";
import History from "../../../History";
import { CancelToken } from 'axios';
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    logo: {
        width: "250px",
        margin: "10px"
    }
});

const ErasureMethodEdit = props => {
    const { classes, onLoadErasureMethod, onLoadErasureMethodInit, activeCustomerID, translations, permissions, onEditErasureMethod, onListSupportedClientTypes, erasureMethod } = props;
    const [editData, setEditData] = useState({ supportedClientTypes: [], formattedSupportedClientTypes: [], loadingData: true });

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            await onLoadErasureMethod({ ActiveCustomerID: activeCustomerID, ErasureMethodID: parseURL(window.location.href).ErasureMethodID }, { cancelToken: requestToken.token })
        }
        fetchData();
        return () => {
            requestToken.cancel('Operation canceled by the user.');
            onLoadErasureMethodInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const formatSupportedClientTypes = useCallback(async (supportedClientTypes = [], erasureMethodSupportedClientTypes = []) => {
        let supportedClientTypesIDs = erasureMethodSupportedClientTypes.map(supportedClientType => supportedClientType.SupportedClientTypeID);
        return supportedClientTypes.filter(supportedClientType => supportedClientTypesIDs.includes(supportedClientType.value));
    }, []);

    const formatErasureMethodData = useCallback(async (erasureMethod, requestToken) => {
        let supportedClientTypes = await onListSupportedClientTypes({ ActiveCustomerID: activeCustomerID }, { cancelToken: requestToken.token });
        let formattedSupportedClientTypes = await formatSupportedClientTypes(supportedClientTypes, erasureMethod.SupportedClientTypes);
        setEditData({ supportedClientTypes: supportedClientTypes, formattedSupportedClientTypes: formattedSupportedClientTypes, loadingData: false });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const requestToken = CancelToken.source();
        if (erasureMethod && Object.keys(erasureMethod).length > 0) {
            formatErasureMethodData(erasureMethod, requestToken);
        }
        return () => {
            requestToken.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [erasureMethod]);

    const extractSupportedClientTypes = selectedSupportedClientTypes => {
        return selectedSupportedClientTypes.map(supportedClientType => supportedClientType.value);
    };


    const handleSubmit = async data => {
        let formData = { ...data };
        formData['SupportedClientTypeIDs'] = extractSupportedClientTypes(formData.SupportedClientTypes);
        delete formData.SupportedClientTypes;
        let result = await onEditErasureMethod({ ...formData, ActiveCustomerID: activeCustomerID, ErasureMethodID: parseURL(window.location.href).ErasureMethodID });
        if (result) {
            setEditData({ supportedClientTypes: [], formattedSupportedClientTypes: [], loadingData: true });
            History.goBack();
        }
    };

    let initialValues = {
        Key: erasureMethod?.Key || "",
        Visible: erasureMethod?.Visible || false,
        LongName: erasureMethod?.LongName || "",
        ShortName: erasureMethod?.ShortName || "",
        SupportedClientTypes: editData.formattedSupportedClientTypes,
        DedicatedFor: erasureMethod?.DedicatedFor || "all",
        Description: erasureMethod?.Description || "",
    };

    let formSettings = {
        Validation: {
            Key: Yup.string().required("Required"),
            LongName: Yup.string().required("Required"),
            ShortName: Yup.string().required("Required"),
            DedicatedFor: Yup.string().required("Required"),
        },
        FormTitle: translations["edit_securaze_standard"] || "Edit securaze standard",
        ButtonSubmit: hasPermission(permissions, "erasure_method_save")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null
    };

    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={editData.loadingData}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }}
            >
                <AppLogoLoading />
            </Dialog>
            {!editData.loadingData ?
                <ErasureMethodForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    translations={translations}
                    supportedClientTypes={editData.supportedClientTypes}
                    edit={true}
                />
                : null}
        </Paper>
    );
};
const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        erasureMethod: state.admin.erasureMethod.loaded,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onLoadErasureMethodInit: erasureMethod => dispatch(actions.loadErasureMethodInit(erasureMethod)),
        onLoadErasureMethod: (erasureMethod, option) => dispatch(actions.loadErasureMethod(erasureMethod, option)),
        onEditErasureMethod: erasureMethod => dispatch(actions.editErasureMethod(erasureMethod)),
        onListSupportedClientTypes: (data, option) => dispatch(actions.listSupportedClientTypes(data, option)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ErasureMethodEdit));
